import React from 'react';
import { useDispatch } from 'react-redux';
import { currencyFormatter } from '../../../../utils/currency';
import Icon from '../../elements/icon';
import { useAddManualMutation, useRemoveManualMutation } from '../../../../store/newCart';
import { startLoading } from '../../../../store/application';
import i18n from '../../../../utils/translations/i18n';
import { mobileAndTabletDetection } from "../../../../utils/browser";
import {ReactComponent as GreenTick} from "../../../../assets/icons/green-tick.svg";

const ApplicableAdditionalCharge = (props: any) => {
    const { t } = i18n;
    const dispatch = useDispatch();
    const mainItem: any = props.cart.lineItems[props.lineItemId][0].data;
    const applicableAdditionalCharges: any = props.applicableAdditionalCharges;
    const appliedChargeCodes: any = props.appliedChargeCodes;
    const [addManual] = useAddManualMutation();
    const [removeManual] = useRemoveManualMutation();

    const addManualHandler = (event) => {
        dispatch(startLoading());
        addManual({cartId: props.cart.id, lineItemId: mainItem.id, additionalChargeCode: event.currentTarget.parentNode.getAttribute('data-code')});
    }

    function removeManualAdditionalCharge(applicableChargeData) {
        dispatch(startLoading());
        removeManual({ cartId: props.cart.id, lineItemId: mainItem.id, additionalChargeCode: applicableChargeData.code });
    }

    return applicableAdditionalCharges.map((data) => {
        let applicableChargeData = data.data;
        const isAdded = appliedChargeCodes.indexOf(applicableChargeData.code) !== -1;
        return <React.Fragment key={applicableChargeData.id}>
                {
                    <div className={`shopping-bag__promo manual-charges ${isAdded ? 'upsellAdded' : 'upsellNotAdded'}`} data-code={applicableChargeData.code}>
                        {!isAdded && <Icon className="upsellAdd btn" onClick={addManualHandler} color="$color-subtle-text-new" ><span className="icon-plus"></span>{t('shopping_cart_details.add_text')}</Icon>}
                        <div>
                            <div className="shopping-bag__promo__title_additional_charge">
                                <span> {isAdded && !mobileAndTabletDetection() && t('header.logo_imprint_added')} {applicableChargeData.name} {t('for')} <span className="upsellPrice">{currencyFormatter(applicableChargeData.value, props.cart.fractionDigits)}</span> {applicableChargeData.type === 'perUnitExtraCharges' && <> {t('shopping_cart_details.manual_each')}</>}</span>
                            </div>
                            {isAdded && <div className='upsell-remove' tabIndex={0} role="button" onClick={() => removeManualAdditionalCharge(applicableChargeData)}>{t('shopping_cart_details.removeButton')}</div>}
                        </div>
                        {isAdded && <div className='child-container green-tick-container'><GreenTick /></div>}
                    </div>
                }
            </React.Fragment>
    })
}

export default ApplicableAdditionalCharge;
